export const buildCollaborationRoomName = ({
  projectUuid,
  scriptUuid,
  feature = 'editor',
  sceneUuid
}) => {
  if (!projectUuid) {
    throw new Error('projectUuid is required')
  }

  if (!scriptUuid) {
    throw new Error('scriptUuid is required')
  }

  return `${projectUuid}:${scriptUuid}:${feature}${sceneUuid ? `:${sceneUuid}` : ''}`
}

export const buildCollaborationSocketUrl = ({ socketHost, roomName }) => {
  if (!socketHost) {
    throw new Error('socketHost is required')
  }

  if (!roomName) {
    throw new Error('roomName is required')
  }

  return `${socketHost}/shared_project/${roomName}`
}
